import { render, staticRenderFns } from "./bills-receivable-table.vue?vue&type=template&id=d2757c32&scoped=true"
import script from "./bills-receivable-table.vue?vue&type=script&lang=js"
export * from "./bills-receivable-table.vue?vue&type=script&lang=js"
import style0 from "./bills-receivable-table.vue?vue&type=style&index=0&id=d2757c32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2757c32",
  null
  
)

export default component.exports